import { ICircle } from 'src/app/_core/interfaces/ICircle'
import { ElementType } from 'src/app/_core/models/ToolboxModel'
import { Profile } from './profile.model'
import { LayerLevel } from '../../interfaces/LayerLevel';

export class LED extends Profile {

    selected: boolean;

    get type(): ElementType {
        return ElementType.Led;
    }

    get name(): string {
        return $localize`:Common|LED:LED`;
    }

    get layer(): LayerLevel {
        return LayerLevel.Middle;
    }

	protected _optionName: string;
	get optionName(): string {
		return this._optionName;
	}

    constructor(cid: string, public circleNumber: number, public circle: ICircle = null) {
        super();

        this.configId = cid;
        this.color = circleNumber % 2 ? 'yellow' : 'red';
        this._optionName = "LED";
    }
}
